'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandingLink = function BrandingLink(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      href = _ref.href;

  return _react2.default.createElement(
    _UILink2.default,
    {
      style: { color: _colors.LORAX },
      href: href,
      onClick: onClick,
      target: '_blank'
    },
    children
  );
};

BrandingLink.propTypes = {
  children: _react.PropTypes.node.isRequired,
  href: _react.PropTypes.string,
  onClick: _react.PropTypes.func
};

BrandingLink.defaultProps = {
  href: '',
  onClick: function onClick() {}
};

exports.default = BrandingLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/BrandingLink.js
// module id = 1080
// module chunks = 2 3